  <template >

 <div>

     <template>
  <v-container class="grey lighten-5" v-role="'func'">
    <v-btn  class="mx-2" fab dark color="primary" @click="$router.push('menu-estatistica')">
      <v-icon dark>arrow_back</v-icon>
    </v-btn>
      <div class="text-center">
      <v-progress-circular v-if="progresso"
      indeterminate
      color="primary"
    >Aguarde...</v-progress-circular>
   </div>
    <v-row no-gutters>
      <v-col cols="12" md="1" >
         </v-col>
       <v-col cols="12" md="2" >
            <v-select
              v-model="editedItem.descricao"
              item-value="descricao"
              item-text="novadescricao"
              @change="quantAlunosPorClasse(editedItem.descricao)"
              :items="anoLectivo"
              :disabled="isUpdating"
              filled
              color="blue-grey lighten-2"
              label="Ano Lectivo"
            ></v-select>
          </v-col>

          <v-col cols="12" md="9">
      <input type="radio" name="gender" v-model="row" value="1"> Área
  <input type="radio" name="gender" v-model="row" value="2"> Barras
  <input type="radio" name="gender" v-model="row" value="3"> Pie
  <input type="radio" name="gender" v-model="row" value="4"> Radar
  <input type="radio" name="gender" v-model="row" value="5"> Line
            </v-col>

</v-row>
<v-row>
      <v-col >

      <div class="container">

    <Doughnut
      v-if="loaded && row==='1'"
      :chartdata="chartdata"
      :options="options"/>

       <Bar
      v-if="loaded && row==='2'"
      :chartdata="chartdata"
      :options="options"/>

       <Pie
      v-if="loaded && row==='3'"
      :chartdata="chartdata"
      :options="options"/>

       <Radar
      v-if="loaded && row==='4'"
      :chartdata="chartdata"
      :options="options"/>

       <LineChart
      v-if="loaded && row==='5'"
      :chartdata="chartdata"
      :options="options"/>

  </div>

      </v-col>

    </v-row>
  </v-container>
</template>

 </div>
</template>

<script>

import axios from '../../../plugins/axios'
const ls = require('local-storage')
export default {
  name: 'BarChartContainer',
  componentsBar: {
    LineChart: () => import('../../../components/Area.vue')

  },
  components: {
    Doughnut: () => import('../../../components/Area.vue'),
    Bar: () => import('../../../components/Bar.vue'),
    LineChart: () => import('../../../components/Chart.vue'),
    Radar: () => import('../../../components/Radar.vue'),
    Pie: () => import('../../../components/Pie.vue')
  },
  data: () => ({
    row: null,
    professores: [],
    anoLectivo: [],
    progresso: false,
    isUpdating: false,
    loaded: false,
    anoAcademico: [],
    quantProfessores: [],
    editedItem: {
      idAnoLectivo: 0,
      descricao: ls.get('anolectivo'),
      status_2: false
    },
    chartdata: {
      labels: [],
      datasets: [
        {
          label: 'Quantidade de professores na classe',
          backgroundColor: ['rgba(255, 99, 71, 0.8)', 'rgb(60, 179, 113)', 'rgb(0, 0, 255)', 'rgb(255, 165, 0)'],
          data: [0, 0, 0, 0]
        }

      ]
    },

    options: {
      responsive: true,
      legend: {
        display: true,
        position: 'top',
        labels: {
          fontColor: 'rgb(255, 99, 132)'
        }
      },
      maintainAspectRatio: false
    }
  }),
  async mounted () {
    this.loaded = false
    try {
      //  const { userlist } = await fetch('/api/userlist')
      // this.chartdata = ['January', 'February']
      this.loaded = true
    } catch (e) {
      console.error(e)
    }
  },
  watch: {
    chartData () {
      this.$data._chart.update()
    }
  },
  created () {
    // check if classe has been selected otherwise send back to painel to select
    this.anoLectivoAll()
    this.quantAlunosPorClasse(ls.get('anolectivo'))
  },
  methods: {
    async anoLectivoAll () {
      try {
        this.anoLectivo = await axios
          .get('/allAnoLectivo/')
          .then(res => res.data)
        this.row = '1'
      } catch (error) {
        console.log('errrrrrrrrrrrrrrrrrrro' + error)
        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async quantAlunosPorClasse (anolectivo) {
      try {
        this.progresso = true
        this.professores = await axios
          .get('/quantidadeFuncionarios_Classe/' + anolectivo)
          .then(res => res.data)
        this.filterProfessores_Classe()
      } catch (error) {
        this.text = error
        this.$store.dispatch('textMessage', {
          msg: this.text,
          classMessage: 'msgError',
          timeout: 3000
        })
      } this.progresso = false
    },
    filterProfessores_Classe () {
      this.anoAcademico = []
      this.quantProfessores = []
      for (let index = 0; index < this.professores.length; index++) {
        this.anoAcademico[index] = (this.professores[index].classe)
        this.quantProfessores[index] = (this.professores[index].quantidade)
      }
      this.chartdata.labels = this.anoAcademico
      this.chartdata.datasets[0].data = this.quantProfessores

      this.loaded = false

      this.$nextTick(() => {
        this.loaded = true
      })
    }

  }
}
</script>

<style>
  .small {
    max-width: 600px;
    margin:  150px auto;
  }
</style>
